// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1WN_W","row":"Node_row__3G_h4","label":"Node_label__2YbjT","footer":"Node_footer__2Ac1Y"};